require('./brokerETFsSellView.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { OKCover } = require('commonsComponents/OKCover');
const { OKButton } = require('commonsComponents/OKButton');
const OKBadge = require('components/commons/OKBadge/OKBadge');

// @ components
const BrokerETFsHeader = require('components/broker/brokerProductHeaders/brokerETFsHeader/brokerETFsHeader');
const {
    BrokerETFsSellStep1
} = require('components/broker/brokerETFsSell/brokerETFsSellStep1/brokerETFsSellStep1');
const BrokerETFsSellStep2 = require('components/broker/brokerETFsSell/brokerETFsSellStep2/brokerETFsSellStep2');
const BrokerETFsSellSuccess = require('components/broker/brokerETFsSell/brokerETFsSellSuccess/brokerETFsSellSuccess');
const BrokerTruncatedBreadcrumb = require('components/broker/brokerTruncatedBreadcrumb/brokerTruncatedBreadcrumb');
const WebappRender = require('components/conditionalRender/webappRender')
const FeatureTogglingRender = require("../../../components/conditionalRender/featureTogglingRender");
// @ actions
const BrokerETFsSellActions = require('actions/brokerETFsSell');
const ProductFileActions = require('actions/brokerGetProductFile.js');
const BrokerOpenTraderActions = require('actions/brokerOpenTrader');
const ProductETFsFileActions = require('actions/brokerETFsProduct');
const CollectivesCommissionsInfoAction = require('actions/collectivesCommissions');

// @ constants
const {
    BROKER_ETFS_HELP_URL,
    MYPROFILE_BROKER_EXPLORE_URL,
    MYPROFILE_BROKER_URL,
    FIRST_STEP,
    SECOND_STEP,
    COLLECTIVE_ETF_SELL,
    BROKER_SELL_SCREEN
} = require('constants/index');

const { SELL_ETFS_HELP_LINK, OPENTRADER } = require('constants/flagBasedFeatures');

// @utils
const { scrollToTop } = require('commonsUtilities/scrollUtils');

class BrokerETFsSellView extends React.Component {
    constructor(props) {
        super(props);
        this.getProductDetails = this.getProductDetails.bind(this);
        this.onCancel = this.onCancel.bind(this);
    }

    componentDidMount() {
        const { immProfile, getETFsCatalogueDetails, history, match: { params: { isin } } } = this.props;

        this.getProductDetails();
        this.props.fetchOpenTraderLink();
        getETFsCatalogueDetails(isin);
        scrollToTop();

        if (immProfile.get('isCollective')) {
            this.props.getCollectivesCommissionsInfo(COLLECTIVE_ETF_SELL, history);
        }
    }

    componentWillUnmount() {
        this.props.reset();
        this.props.resetProduct();
    }

    onCancel() {
        this.props.history.push(MYPROFILE_BROKER_URL);
    }

    getBreadcrumbData(productFile, isin, iso) {
        return [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('breadcrumb-brokerAdvancedSearch'),
                url: MYPROFILE_BROKER_EXPLORE_URL
            },
            {
                text: productFile.get('companyName'),
                url: `/myprofile/broker/etfsProductFile/${isin}/${iso}`
            },
            {
                text: formatText('breadcrumb-brokerStocksSell'),
                url: ''
            }
        ];
    }

    getProductDetails() {
        const { getProductDetails, match: { params: { isin, iso } } } = this.props;

        getProductDetails(isin, iso, BROKER_SELL_SCREEN);
    }

    buildSuccessful() {
        const { immBrokerETFsSell, immStocksContracts, productFile } = this.props;

        return (
            <div className="broker-etfs-sell-view__success col-lg-12">
                <BrokerETFsSellSuccess
                    productFile={productFile}
                    immBrokerETFsSell={immBrokerETFsSell}
                    immStocksContracts={immStocksContracts}
                />
            </div>
        );
    }

    buildWizard() {
        const {
            setVisibleStep,
            setWillCancel,
            validateStep,
            immBrokerETFsSell,
            immStocksContracts,
            match: { params },
            productFile,
            finish,
            handleChangeReadChecked,
            immProfile,
            immCollectivesCommissions,
            flagBasedFeatures,
            getExAnteData
        } = this.props;

        const immSteps = immBrokerETFsSell.get('steps');
        const visibleStep = immBrokerETFsSell.get('visibleStep');
        const firstStepLoading = immBrokerETFsSell.getIn(['steps', FIRST_STEP, 'loading']);
        const secondStepLoading = immBrokerETFsSell.getIn(['steps', SECOND_STEP, 'loading']);
        const etfCommisionsLinkUrl = formatText('broker-product_buy_sale_flow_see_fees_link');

        const actions = {
            setVisibleStep,
            validateStep,
            cancel: this.onCancel,
            setWillCancel,
            finish
        };

        const titleHeaderMenuWizard = visibleStep === 1 ? formatText('broker-etfsSellViewWizardTitle') : formatText('broker-etfsSellViewWizardTitleStepTwo');

        const headerMenuData = {
            title: titleHeaderMenuWizard,
            linksData: [
                ...flagBasedFeatures.get(SELL_ETFS_HELP_LINK) ? {
                    label: formatText('broker-etfsSellViewWizardThirdLinkLabel'),
                    href: BROKER_ETFS_HELP_URL,
                    hasTooltip: false,
                    target: '_blank'
                } : []
            ]
        };

        const isCollectiveUser = !!immProfile.get('isCollective');

        if (isCollectiveUser) {
            const collectivesUrl = immCollectivesCommissions.get('url');
            headerMenuData.extraContent = <OKBadge toUrl={collectivesUrl} target={'_blank'} name={formatText('broker-etfsBuyWizardBadgeLabel').toUpperCase()} />;
        } else {
            headerMenuData.linksData.push({
                label: formatText('broker-etfBuyViewWizardFirstLinkLabel'),
                href: etfCommisionsLinkUrl,
                hasTooltip: false,
                target: '_blank'
            });
        }

        return (
            <Wizard
                wizardClass={'broker-etfs-sell-view__wizard'}
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={visibleStep}
                hasHeaderMenu={true}
                headerMenuData={headerMenuData}>
                <WizardStep position="first" cancelButton={true} isLoading={firstStepLoading}>
                    <BrokerETFsSellStep1 params={params} />
                </WizardStep>
                <WizardStep
                    position="last"
                    immFinalButton="broker-etfsSellViewFinishButtonLabel"
                    cancelButton={true}
                    isLoading={secondStepLoading}
                >
                    <BrokerETFsSellStep2
                        productFile={productFile}
                        immBrokerETFsSell={immBrokerETFsSell}
                        immStocksContracts={immStocksContracts}
                        handleChangeReadChecked={handleChangeReadChecked}
                        getExAnteData={getExAnteData}
                        immFlagBasedFeatures={flagBasedFeatures}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    handleOnClick = () => {
        this.props.history.push(MYPROFILE_BROKER_EXPLORE_URL);
    }

    render() {
        const {
            flagBasedFeatures,
            immBrokerETFsSell,
            immETFProduct,
            immMyInvestments,
            immOpenTrader,
            match: { params },
            productFile,
        } = this.props;

        const mappingBreadcrumb = this.getBreadcrumbData(productFile, params.isin, params.iso);
        const isCryptoETF = immETFProduct.get('isCryptoETF');
        const subtitle = isCryptoETF ? (
            <FormattedText value={"broker-etfsCriptoSummaryProductName"} />
        ) : (
            <FormattedText value={"broker-etfSummaryProductName"} />
        );
        let contractBoxContent;

        if (immBrokerETFsSell.get('submitSuccessful')) {
            contractBoxContent = this.buildSuccessful();
        } else {
            contractBoxContent = this.buildWizard();
        }

        return (
            <div className="broker-etfs-sell-view">
                <OKCover size="medium" section="broker">
                    <BrokerTruncatedBreadcrumb
                        titleKey="broker-etfsSellViewTitle"
                        breadcrumbConfig={mappingBreadcrumb}
                        subtitleLeft={subtitle}
                        className="broker-etfs-sell-view__header"
                    >
                        <OKButton inverse={true} modifier="ghost" onClick={() => this.handleOnClick()}>
                            <FormattedText format="firstUppercase" value="broker-goToAdvancedSearch" />
                        </OKButton>
                        <FeatureTogglingRender notAllowedProductKey={OPENTRADER}>
                            <WebappRender>
                                <OKButton inverse={true} modifier="primary" to={immOpenTrader.get('openTraderLink')}>
                                    <FormattedText format="firstUppercase" value="broker-openTraderLabel" />
                                </OKButton>
                            </WebappRender>
                        </FeatureTogglingRender>
                    </BrokerTruncatedBreadcrumb>
                </OKCover>
                <section className="broker-etfs-sell-view__body">
                    <BrokerETFsHeader
                        etfsProduct={immETFProduct}
                        handleUpdate={this.getProductDetails}
                        immFlagBasedFeatures={flagBasedFeatures}
                        immMyInvestments={immMyInvestments}
                        noBottomButtons={true}
                        productFile={productFile}
                    />
                    <div className="broker-etfs-sell-view__wizard">
                        {contractBoxContent}
                    </div>
                </section>
            </div>
        );
    }
}

BrokerETFsSellView.propTypes = {
    etfsProduct: PropTypes.object,
    fetchOpenTraderLink: PropTypes.func.isRequired,
    finish: PropTypes.func,
    flagBasedFeatures: PropTypes.object.isRequired,
    getCollectivesCommissionsInfo: PropTypes.func,
    getETFsCatalogueDetails: PropTypes.func.isRequired,
    getExAnteData: PropTypes.func,
    getProductDetails: PropTypes.func,
    handleChangeReadChecked: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immBrokerETFsSell: PropTypes.object,
    immCollectivesCommissions: PropTypes.object.isRequired,
    immETFProduct: PropTypes.object.isRequired,
    immMyInvestments: PropTypes.object.isRequired,
    immOpenTrader: PropTypes.object.isRequired,
    immProfile: PropTypes.object,
    immStocksContracts: PropTypes.object,
    immVariables: PropTypes.object.isRequired,
    match: PropTypes.object,
    productFile: PropTypes.object,
    reset: PropTypes.func,
    resetProduct: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func,
    setWillCancel: PropTypes.func,
    validateStep: PropTypes.func,
};

module.exports.constructor = BrokerETFsSellView;
module.exports.BrokerETFsSellView = connect(
    state => ({
        flagBasedFeatures: state.flagBasedFeatures,
        immBrokerETFsSell: state.brokerETFsSell,
        immCollectivesCommissions: state.collectivesCommissions,
        immETFProduct: state.brokerETFsProduct,
        immMyInvestments: state.brokerMyInvestments,
        immOpenTrader: state.brokerOpenTrader,
        immProfile: state.profile,
        immStocksContracts: state.brokerStocksContract,
        immVariables: state.globalVariables.get('variables'),
        productFile: state.brokerProductFile,
    }),
    {
        reset: BrokerETFsSellActions.reset,
        setVisibleStep: BrokerETFsSellActions.setVisibleStep,
        setWillCancel: BrokerETFsSellActions.setWillCancel,
        validateStep: BrokerETFsSellActions.validateStep,
        finish: BrokerETFsSellActions.finish,
        getExAnteData: BrokerETFsSellActions.getExAnteData,
        getProductDetails: ProductETFsFileActions.getProductFile,
        getETFsCatalogueDetails: ProductETFsFileActions.getETFsCatalogueDetails,
        resetProduct: ProductFileActions.reset,
        fetchOpenTraderLink: BrokerOpenTraderActions.fetchLink,
        handleChangeReadChecked: BrokerETFsSellActions.changeReadChecked,
        getCollectivesCommissionsInfo: CollectivesCommissionsInfoAction.getCollectivesCommissionsInfo
    }
)(withRouter(BrokerETFsSellView));
